import { getStoredSessionToken } from '../../../app/services/session.service';

const BASE_URL = (process.env.REACT_APP_ACCOUNTING_API_BASE_URL || '').replace(/\/$/, '');
const ROOT = '/api/accounting/custom-fields';

function headers(extra = {}) {
  const token = getStoredSessionToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : extra;
}

async function payloadOrError(response) {
  let payload = null;
  try { payload = await response.clone().json(); } catch { /* empty response */ }
  if (!response.ok) throw new Error(payload?.message || payload?.error || 'Campi personalizzati non disponibili.');
  return payload;
}

export async function listAccountingCustomFields(formKey) {
  const response = await fetch(`${BASE_URL}${ROOT}/${encodeURIComponent(formKey)}`, { headers: headers() });
  return payloadOrError(response);
}

export async function createAccountingCustomField(definition, formKey) {
  const response = await fetch(`${BASE_URL}${ROOT}/${encodeURIComponent(formKey)}`, {
    method: 'POST',
    headers: headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(definition),
  });
  return payloadOrError(response);
}

export async function archiveAccountingCustomField(id, formKey) {
  const response = await fetch(`${BASE_URL}${ROOT}/${encodeURIComponent(formKey)}/${id}`, {
    method: 'DELETE',
    headers: headers(),
  });
  return payloadOrError(response);
}
